import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles, categories } from '@/mocks/articles';

const categoryHeroImages: Record<string, string> = {
  wanghong: "https://readdy.ai/api/search-image?query=Dark%20moody%20atmosphere%20influencer%20scandal%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20amber%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-wanghong&orientation=landscape",
  mingxing: "https://readdy.ai/api/search-image?query=Dark%20moody%20celebrity%20downfall%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20golden%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-mingxing&orientation=landscape",
  redian: "https://readdy.ai/api/search-image?query=Dark%20moody%20breaking%20news%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20amber%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-redian&orientation=landscape",
  bagua: "https://readdy.ai/api/search-image?query=Dark%20moody%20entertainment%20gossip%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-bagua&orientation=landscape",
  shipin: "https://readdy.ai/api/search-image?query=Dark%20moody%20video%20surveillance%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-shipin&orientation=landscape",
  shenba: "https://readdy.ai/api/search-image?query=Dark%20moody%20investigation%20theme%20with%20dramatic%20lighting%20cinematic%20composition%20warm%20amber%20accent%20high%20contrast&width=1920&height=600&seq=cat-hero-shenba&orientation=landscape",
};

const categoryArticleImages: Record<string, string> = {
  "dingji-wanghong-renshe-bengta": "https://readdy.ai/api/search-image?query=Dark%20moody%20influencer%20scandal%20smartphone%20leaked%20messages%20warm%20amber%20lighting%20cinematic%20noir%20high%20contrast&width=600&height=400&seq=cat-list-wanghong-01&orientation=landscape",
  "wanghong-daihuo-jia-mao-zhengshu": "https://readdy.ai/api/search-image?query=Dark%20desk%20fake%20certificate%20magnifying%20glass%20revealing%20forgery%20moody%20atmosphere%20warm%20amber%20cinematic%20editorial&width=600&height=400&seq=cat-list-wanghong-02&orientation=landscape",
  "dingji-mingxing-shuiwu-weigui": "https://readdy.ai/api/search-image?query=Dark%20celebrity%20tax%20investigation%20luxury%20items%20documents%20moody%20lighting%20cinematic%20noir%20high%20contrast&width=600&height=400&seq=cat-list-mingxing-01&orientation=landscape",
  "xianggang-dingji-yiren-bei-ju-bao": "https://readdy.ai/api/search-image?query=Dark%20Hong%20Kong%20night%20financial%20district%20luxury%20mystery%20cinematic%20reflections%20shadows%20high%20contrast&width=600&height=400&seq=cat-list-mingxing-02&orientation=landscape",
  "zhibo-daihuo-jiahuo-neimu": "https://readdy.ai/api/search-image?query=Dark%20live%20streaming%20scandal%20packages%20scattered%20moody%20lighting%20cinematic%20investigative%20journalism%20high%20contrast&width=600&height=400&seq=cat-list-redian-01&orientation=landscape",
  "liangyi-jie-baoguang-yiliao-shigu": "https://readdy.ai/api/search-image?query=Dark%20medical%20surgical%20tools%20shadow%20moody%20atmosphere%20cinematic%20lighting%20high%20contrast%20warm%20accent&width=600&height=400&seq=cat-list-redian-02&orientation=landscape",
  "jianju-huizhan-baoliao-chigua-quanjilu": "https://readdy.ai/api/search-image?query=Dark%20year%20in%20review%20calendar%20pages%20dramatic%20lighting%20moody%20highlights%20cinematic%20warm%20golden%20hour&width=600&height=400&seq=cat-list-redian-03&orientation=landscape",
  "nv-tuan-chengyuan-bei-ba-ling": "https://readdy.ai/api/search-image?query=Dark%20K-pop%20girl%20group%20dramatic%20shadows%20silhouettes%20backstage%20tension%20cinematic%20lighting%20high%20contrast&width=600&height=400&seq=cat-list-bagua-01&orientation=landscape",
  "wangluo-zhubo-bei-qi-pian-ji-qian-wan": "https://readdy.ai/api/search-image?query=Dark%20gaming%20room%20empty%20chair%20scattered%20money%20moody%20atmosphere%20deception%20cinematic%20warm%20accent%20high%20detail&width=600&height=400&seq=cat-list-bagua-02&orientation=landscape",
  "shipin-paishedao-luren-gongkai": "https://readdy.ai/api/search-image?query=Dark%20nighttime%20street%20luxury%20hotel%20silhouettes%20dramatic%20lights%20paparazzi%20style%20cinematic%20noir%20high%20contrast&width=600&height=400&seq=cat-list-shipin-01&orientation=landscape",
  "dahu-shangye-jiaoyi-beihou": "https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20documents%20money%20sophisticated%20investigation%20moody%20lighting%20cinematic%20high%20contrast&width=600&height=400&seq=cat-list-shenba-01&orientation=landscape",
  "duanshipin-pingtai-neirong-zhengce": "https://readdy.ai/api/search-image?query=Dark%20content%20moderation%20screens%20social%20media%20feeds%20shadow%20moody%20tech%20surveillance%20cinematic%20high%20contrast&width=600&height=400&seq=cat-list-shenba-02&orientation=landscape",
};

const articleCardsByCategory: Record<string, typeof articles> = {};
categories.forEach((cat) => {
  articleCardsByCategory[cat.slug] = articles.filter((a) => a.category === cat.id);
});

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? articleCardsByCategory[slug] || [] : [];

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": `${category.name} - 51吃瓜爆料网`,
    "description": category.description,
    "url": `https://www.chigua51.com/category/${category.slug}`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "51吃瓜爆料网",
      "url": "https://www.chigua51.com",
    },
  };

  const heroImage = categoryHeroImages[category.slug] || categoryHeroImages.wanghong;

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }} />
      <Navbar />
      <main>
        <section className="relative h-72 md:h-80 overflow-hidden">
          <img
            src={heroImage}
            alt={category.name}
            className="w-full h-full object-cover object-top"
            title={`${category.name} - ${category.description}`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-10 lg:px-20">
              <div className="max-w-3xl">
                <div className="mb-3">
                  <Breadcrumb
                    items={[
                      { label: "首页", href: "/" },
                      { label: category.name },
                    ]}
                  />
                </div>
                <h1 className="text-3xl md:text-5xl font-black font-heading text-background-50 mb-2">
                  {category.name}
                </h1>
                <p className="text-sm md:text-base text-background-50/70 max-w-xl">{category.description}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                共 {categoryArticles.length} 篇爆料
              </h2>
            </div>

            {categoryArticles.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-foreground-400">该分类暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => {
                  const articleImage = categoryArticleImages[article.slug] || categoryHeroImages[category.slug];
                  return (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
                    >
                      <div className="relative h-48 md:h-56 overflow-hidden">
                        <img
                          src={articleImage}
                          alt={article.title}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                          title={article.title}
                        />
                        {article.trending && (
                          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium flex items-center gap-1">
                            <i className="ri-fire-line text-[10px]"></i> 热门
                          </span>
                        )}
                        {article.featured && (
                          <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                            独家
                          </span>
                        )}
                      </div>
                      <div className="p-4 md:p-5 flex flex-col flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="tag-accent text-[10px]">{category.name}</span>
                          <span className="text-foreground-400 text-xs">{article.publishedAt}</span>
                        </div>
                        <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                          {article.title}
                        </h3>
                        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                          {article.summary}
                        </p>
                        <div className="flex items-center gap-3 text-foreground-400 text-xs pt-2 border-t border-background-100">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i> {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-user-line"></i> {article.author}
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}